module.exports = __webpack_public_path__ + "img/subAra9.caa0109c.jpg";